import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { Button } from "react-bootstrap";
import { useAddPmxActivityFavoriteMutation } from "../../backend/hooks/pmxActivity/favorite/mutationAddPmxActivityFavorite";
import { useRemovePmxActivityFavoriteMutation } from "../../backend/hooks/pmxActivity/favorite/mutationRemovePmxActivityFavorite";
import { PmxActivity } from "../../backend/types";
import Error from "../abstractComponents/error";

export default function FavoriteButton(props: {
  activity: PmxActivity;
  isFavorited: boolean;
}) {
  const {
    addPmxActivityFavorite,
    loadingAddFavoritesMutation,
    errorAddFavoritesMutation
  } = useAddPmxActivityFavoriteMutation();
  const {
    removePmxActivityFavorite,
    loadingRemoveFavoritesMutation,
    errorRemoveFavoritesMutation
  } = useRemovePmxActivityFavoriteMutation();

  const handleClickFavorites = () => {
    if (props.isFavorited) {
      removePmxActivityFavorite({
        variables: {
          id: Number(props.activity.id)
        },
        refetchQueries: ["getMyPmxActivitiesFavorites"]
      });
    } else {
      addPmxActivityFavorite({
        variables: {
          id: Number(props.activity.id)
        },
        refetchQueries: ["getMyPmxActivitiesFavorites"]
      });
    }
  };

  return (
    <Button
      variant="link"
      className="float-end favorite_button m-0"
      onClick={handleClickFavorites}
      data-testid="favorite_button"
      data-activitynamefavorite={props.activity.trialNumber}
      disabled={loadingAddFavoritesMutation || loadingRemoveFavoritesMutation}
    >
      {props.isFavorited ? (
        <StarIcon className="secondary_color favorite_icon is_favorited m-0" />
      ) : (
        <StarBorderIcon className="secondary_color favorite_icon is_not_favorited m-0" />
      )}
      {(errorAddFavoritesMutation || errorRemoveFavoritesMutation) && (
        <Error
          error={errorAddFavoritesMutation || errorRemoveFavoritesMutation}
        />
      )}
    </Button>
  );
}
